import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { VisaRequestedDetailView } from "./VisaRequestedDetailView";
import { getVisaApplicationById } from "../../../services/visaService";
import { mapVisaApplicationToDetailModel } from "../../../mappers/visaApplication.mapper";
import { VisaRequestedDetailModel } from "../../../types/VisaRequestedDetailModel";
import { FullScreenLoading } from "../../../components/ui/loader";

export const VisaApplicantDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [applicant, setApplicant] =
    useState<VisaRequestedDetailModel | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;

    const loadApplicant = async () => {
      try {
        const res = await getVisaApplicationById(Number(id));
        const mapped = mapVisaApplicationToDetailModel(res);

        setApplicant(mapped);
      } catch (err) {
        console.error("Failed to load visa application", err);
      } finally {
        setLoading(false);
      }
    };

    loadApplicant();
  }, [id]);

  if (loading) return <FullScreenLoading />;
  if (!applicant) return <div className="p-6">Applicant not found</div>;

  return (
    <VisaRequestedDetailView
      applicant={applicant}
      // onBack={() => navigate("/visa-document-required")}
      onBack={() => navigate(-1)}
    />
  );
};
